import * as React from "react";
import { Body, Heading } from "@quandoo-dev/cookbook/lib/typography";
import styled from "styled-components";
import { typography, TypographyProps, color, ColorProps } from "styled-system";
import { Box } from "@quandoo-dev/cookbook/lib/layout";

import SectionTitle from "./section-title";
import { constructGoogleMapsUrl } from "../../utils/google-maps";
import useTranslation from "../../hooks/useTranslation";

export interface IAddress {
  lon: number;
  lat: number;
}

interface AddressProps {
  address: IAddress;
  text: string;
  country: string;
}

const Link = styled.a<ColorProps>`
  ${color};
`;

const Address: React.FC<AddressProps> = ({ address, text, country }) => {
  const url = constructGoogleMapsUrl(address);
  const addressText = useTranslation(country, "post.merchant.address");

  return (
    <Box mt="xl">
      <SectionTitle
        letterSpacing="1px"
        fontSize="body.sm"
        fontWeight="semibold"
      >
        {addressText}
      </SectionTitle>
      <Body mt="xs" color="primary" fontWeight="semibold">
        <Link color="blue.50" href={url} target="_blank">
          {text}
        </Link>
      </Body>
    </Box>
  );
};

export default Address;
